import { useRemoteFileValidationQuery } from "server/devplane/remotefiles/queries";
import { formatShortFileName, isColabUrl } from "../utils";

export function useShortFileName(fileName?: string | null): string {
  const value = fileName ?? "";
  const validation = useRemoteFileValidationQuery(value, isColabUrl(value));
  const validatedName =
    validation.status === "success" &&
    validation.fetchStatus === "idle" &&
    validation.data.public
      ? validation.data.fileName
      : undefined;
  return formatShortFileName(value, validatedName);
}
